<script>
  import { onMount } from 'svelte';
  import { SPRITESHEET_URL } from '../../utils/constants';
  import slugify from '../../utils/slugify';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  
  let {
    label,
    content,
    startOpen = false,
    headingLevel = 'h3',
    smallerText = false,
    dataTestId = 'text-expander',
  } = $props();

  let slug = $derived(slugify(label));

  let isOpen = $state(startOpen);
  const toggleExpander = () => {
    isOpen = !isOpen;
  };

  let expanderIcon = $derived(isOpen ? 'collapse' : 'expand');

  onMount(() => {
    const { hash, pathname } = new URL(window.location.href);
    const isHelpTopicPage = pathname.match(/help\/([A-Z]|[a-z]|[0-9]|[-])+/);
    // we only want this programmatic open/close behavior if we are on a help topic page so that hashes on other pages using expanders don't cause unwanted side effects
    if (hash && isHelpTopicPage) {
      const raw = hash.replace('#', '').trim();
      if (raw === slug) {
        isOpen = true;
      } else {
        isOpen = false;
      }
    }
  });
</script>

<div
  id={slug}
  class="border-t border-gray-iron"
  itemscope={true}
  itemprop="mainEntity"
  itemtype="https://schema.org/Question"
>
  <button
    class="px-2 w-full overflow-hidden group focus:relative focus:outline-hidden active:shadow-inset-active focus:shadow-inset-focus"
    onclick={toggleExpander}
    data-testid={dataTestId}
    aria-expanded={isOpen}
  >
    <div
      class="flex text-blue-cerulean hover-hover:group-hover:text-blue-darkish group-active:text-blue-darkish"
      class:py-4={!smallerText}
      class:py-3={smallerText}
    >
      <svg class="w-4 h-4 md:w-6 md:h-6 -ml-1 mr-2 mt-1 fill-current">
        <use xlink:href={`${SPRITESHEET_URL}#${expanderIcon}`} />
      </svg>
      <BaseHeading
        className={`flex-1 font-semibold leading-normal text-base text-left hover-hover:group-hover:underline group-active:underline ${!smallerText ? 'md:text-xl' : 'md:text-lg'}`}
        {headingLevel}
        itemprop="name"
      >
        {label}
      </BaseHeading>
    </div>
  </button>
  <section
    data-testid="text-expander-markdown"
    class="pl-5 pr-4 md:pl-7"
    class:mt-2={!smallerText}
    class:mb-6={!smallerText}
    class:mb-4={smallerText}
    class:hidden={!isOpen}
    itemscope={true}
    itemprop="acceptedAnswer"
    itemtype="https://schema.org/Answer"
  >
    <div class="markdown-wrapper" class:lg:text-lg={!smallerText} itemprop="text">
      {@html content}
    </div>
  </section>
</div>
